<template>
  <div class="car-content car-main-tab-content car-reduced-width">
    <div class="car-booking car-booking-rejected">
      <div class="car-content-introduction">
        <span class="car-headline">{{ $t('quote.appointment.rejected') }}</span>
        <p>{{ $t('quote.appointment.rejectedDescription') }}</p>

        <router-link :to="{ name: 'VehicleIdentification' }" class="car-btn car-btn-primary">
        {{ $t('offer.newSearch') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Rejected'
};
</script>
